import { gql } from '@/utilities/gql';
import type { ResultOf } from '@/utilities/gql';

export const NOTE_REMINDER_FRAGMENT = gql(`
  fragment NoteReminderFields on NoteReminder @_unmask {
    createdAt
    customMessage
    deliveryDateUtc
    entityId
    entityType
    id
    reminderEvent {
      id
      type
      description
    }
    reminderTarget {
      id
      targetKey
      targetValue
      operationType
      targetMetadata
      objectIdentifier
    }
    status
    type
    updatedAt
    userId
    userTimezone
  }
`);

export type NoteReminder = ResultOf<typeof NOTE_REMINDER_FRAGMENT>;
